/**
 * An option of the HubSpot ticket property `city` ("Cidade (Brasil)"). The
 * Zap rejects anything that is not one of these exact `value`s.
 *
 * The list itself lives in vision360 (`GET /api/v1/tickets/cities`) — the
 * single source since PED-14049; read it with `useTicketCities`.
 *
 * `value` is what travels to HubSpot and `label` is what ops sees — a few
 * options drifted apart there (e.g. value "Castanha - PA" labeled
 * "Castanhal - PA"). Sending the label would be rejected.
 */
export interface HubspotCityOption {
  value: string;
  label: string;
}

/** HubSpot's own catch-all for a city that matches no option. */
export const HUBSPOT_CITY_FALLBACK = "Outras";
